import React from 'react';
import ImageContainer from 'components/ImageContainer';
import { IVehicle } from './types';

export function EstimateHeader ({
    vehicle,
}: {
    vehicle: IVehicle,
}) {
    const image = vehicle.thumbImage ?? vehicle.profileImage?.profile;

    return (
        <div className="vehicle-price-estimate-display-new-header">
            <div className="vehicle-price-estimate-display-new-header__image">
                <ImageContainer
                    src={image}
                    alt="vehicle"
                />
            </div>
            <div className="vehicle-price-estimate-display-new-header__info">
                <div>{vehicle.regNumber}</div>
                <div> {vehicle.make} {vehicle.model}</div>
            </div>
        </div>
    );
}
